var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var AuthedUserSession = require('../../../utils/AuthedUserSession');
const React = require("ES/lib/react");
import ModalWrap from "../../widgets/ModalWrap";
import DisconnectStripeModal from "../../marketplace/MoneyTab/DisconnectStripeModal";

module.exports = dd.createClass({
    mixins: [RadioMixin],
    getInitialState: function () {
        return {sid: -1, has_stripe_connected: null, is_reading: false, read_error_msg: null, show_disconnect: false};
    },
    componentWillReceiveProps: function (props) {
        this.__loadForSid(props.selected_sid);
    },
    componentDidMount: function () {
        this.__loadForSid(this.props.selected_sid);
    },
    __loadForSid: function (sid) {
        if (sid != this.state.sid) {
            this.setState({sid: sid, has_stripe_connected: null, is_reading: false, read_error_msg: null}, function () {
                radio('read_Thirdpartyconnection_Stripe_config').broadcast(sid);
            });
        }
    },
    __reloadData: esUtils.wrapPreventDefault(function () {
        this.setState({sid: this.props.selected_sid, has_stripe_connected: null, is_reading: false, read_error_msg: null}, function () {
            radio('read_Thirdpartyconnection_Stripe_config').broadcast(this.props.selected_sid);
        });
    }),
    __toggleDisconnectModal: esUtils.wrapPreventDefault(function () {
        this.setState({show_disconnect: !this.state.show_disconnect});
    }),
    componentWillMount: function () {
        var self = this;
        self.radio = {
            read_Thirdpartyconnection_Stripe_config: function (sid) {
                if (self.state.sid == sid) {
                    self.setState({has_stripe_connected: null, is_reading: true, read_error_msg: null});
                }
            },
            read_Thirdpartyconnection_Stripe_config_succeeded: function (sid, has_it) {
                if (self.state.sid == sid) {
                    self.setState({has_stripe_connected: !!has_it, is_reading: false, read_error_msg: null});
                }
            },
            read_Thirdpartyconnection_Stripe_config_failed: function (sid, message) {
                if (self.state.sid == sid) {
                    self.setState({has_stripe_connected: null, is_reading: false, read_error_msg: 'Failed to read your Stripe connector settings: ' + message});
                }
            }
        };
    },
    render: function () {
        var Displaylists = this.props.Displaylists;
        var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
            return spkr.sid == this.state.sid;
        }, this);

        var connect_url = '/balboa3/stripe/connectspeaker/' + this.state.sid + '?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
        // var disconnect_url = '/balboa3/stripe/disconnectspeaker/' + this.state.sid + '?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
        var modal = null;

        if (this.state.show_disconnect) {
            modal = <DisconnectStripeModal
              sid={this.state.sid}
              reloadData={this.__reloadData}
              onClose={this.__toggleDisconnectModal}
            />;
        }

        return dd.div(null,
            LoadingWrap({is_loading: this.state.is_reading, glass: true},
                dd.h3(null, 'Stripe Payment Processing for ',
                    dd.span({className: 'nametag'},
                        speaker ? speaker.name_full : '')
                ),
                dd.p({className: 'text-muted'},
                    'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ',
                    'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'
                ),
                ErrorAlert({message: this.state.read_error_msg}),
                this.state.has_stripe_connected === true ? dd.div(null,
                    dd.div({className: 'alert alert-success'},
                        'You are connected to Stripe!'
                    ),
                    dd.a({onClick: this.__toggleDisconnectModal, className: 'btn btn-primary'}, 'Disconnect your Stripe account.')
                ) : dd.div(null,
                    dd.p({style:{marginTop: '2em'}},
                        'The button below will take you to Stripe\'s site, where you can create a FREE Stripe account (or choose an existing one) to link to your eSpeakers account. ',
                        'When buyers pay you through the Marketplace platform, the payments will land in your Stripe account and from there to your bank account.'
                    ),
                    dd.p(null,
                        'When Stripe asks if it\'s OK for eSpeakers to access your account, and you should ', dd.b(null, 'choose ALLOW ACCESS'),
                        '.'
                    ),
                    dd.a({href: connect_url, className: 'btn btn-primary'},
                        'Connect to Stripe'
                    ),
                    dd.br(),
                    dd.br()
                )
            ),
            modal && <ModalWrap body={modal} />
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/Stripe.js